export default {
  UPDATE_SELECTED_PAST_INVESTMENT_IO_TYPE_FILTER_VALUE: 'UPDATE_SELECTED_PAST_INVESTMENT_IO_TYPE_FILTER_VALUE',
  UPDATE_SHOW_MORE_PAST_INVESTMENTS: 'UPDATE_SHOW_MORE_PAST_INVESTMENTS',
};
